import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isExpanded: boolean
}

export const Button = styled(ButtonPlain)<Props>`
	padding: 12px;
	display: flex;
	align-items: center;
	column-gap: 4px;
	width: 100%;

	&:hover {
		background-color: ${helpers.color.primaryTranslucent};
		border-radius: ${({ isExpanded }) => (isExpanded ? '3px 3px 0 0' : '3px')};
	}
`
